export default __webpack_public_path__ + "static/media/11.b2e053e1.png";